import { useEffect, useRef } from "react";

export function useLiveRefresh(refresh, enabled = true, intervalMs = 5000) {
  const refreshRef = useRef(refresh);

  useEffect(() => {
    refreshRef.current = refresh;
  }, [refresh]);

  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    let active = true;
    const refreshIfVisible = () => {
      if (!active || document.visibilityState !== "visible") {
        return;
      }

      Promise.resolve(refreshRef.current()).catch(() => undefined);
    };

    const interval = window.setInterval(refreshIfVisible, intervalMs);
    window.addEventListener("focus", refreshIfVisible);
    document.addEventListener("visibilitychange", refreshIfVisible);

    return () => {
      active = false;
      window.clearInterval(interval);
      window.removeEventListener("focus", refreshIfVisible);
      document.removeEventListener("visibilitychange", refreshIfVisible);
    };
  }, [enabled, intervalMs]);
}